import { useEffect } from "react";
import BlogList from "../components/BlogList";
import "./Home.css";
import { useBlogContext } from "context/BlogContext";
import Pagination from "components/Pagination/Pagination";

const Home = () => {
  useEffect(() => {
    document.title = "LIVAD Blog";
  }, []);

  const { blogsIsLoading, pageOptions, setPageOptions, tooManyRequests } =
    useBlogContext();

  return (
    <div className="home">
      <BlogList />

      {!blogsIsLoading &&
        !tooManyRequests &&
        (pageOptions.hasNextPage || pageOptions.page > 0) && (
          <Pagination
            pageOptions={pageOptions}
            setPageOptions={setPageOptions}
          />
        )}
    </div>
  );
};

export default Home;
